// extracted by mini-css-extract-plugin
export default {"avatar":"initials-avatar_avatar__cDRMP"};